import type { Language } from '@rabbit/shared';
import { HelpCircle, X } from 'lucide-react';
import type { Copy } from '../i18n';

export function SettingsSheet({ language, copy, onLanguage, onTutorial, onClose }: { language: Language; copy: Copy; onLanguage: (language: Language) => void; onTutorial: () => void; onClose: () => void }) {
  return <div className="sheet-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className="settings-sheet" role="dialog" aria-modal="true" aria-labelledby="settings-title">
      <header><h2 id="settings-title">{copy.settings}</h2><button className="icon-button" type="button" aria-label={copy.close} onClick={onClose}><X/></button></header>
      <label>{copy.language}<select value={language} onChange={(event) => onLanguage(event.target.value as Language)}><option value="ru">Русский</option><option value="en">English</option></select></label>
      <button className="secondary-button wide" type="button" onClick={onTutorial}><HelpCircle size={18}/>{copy.replayTutorial}</button>
    </section>
  </div>;
}
